import React from 'react';

export default function Files(){
    return (
        <div className={"wrapper__content m--0a d--flex fd--c"}>
            <h1 className={"mt--3 heading--m"}>Files</h1>
        </div>
    )
}